import React from "react";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import AppTableContainer from "@crema/core/AppTableContainer";
import { CategoryData } from "types/models/planMaster/planMasterApp";
import TableHeading from "./TableHeading";
import TableItem from "./TableItem";

interface CategoryTableProps {
  category: CategoryData[];
}

const CategoryTable: React.FC<CategoryTableProps> = ({ category }) => {
  return (
    <AppTableContainer>
      <Table stickyHeader className="table">
        <TableHead>
          <TableHeading />
        </TableHead>
        <TableBody>
          {category.map((data) => (
            <TableItem data={data} key={data.sNo} />
          ))}
        </TableBody>
      </Table>
    </AppTableContainer>
  );
};

export default CategoryTable;
